// initial state
const state = () => ({
  loadedAt: null, // seconds
  popups: [],
});

// getters
const getters = {
  getPopups: state => {
    return state.popups;
  },
  getByEvent: (state) => (event) => {
    return state.popups.find(popup => {
      return popup.event === event;
    });
  },
  getLoadedAt: state => {
    return state.loadedAt;
  },
};

// actions
const actions = {
  loadPopups(context) {
    if ((Date.now() / 1000) - context.getters.getLoadedAt > 60 * 15)
      return axios
        .get('/ajax/popups').then(response => {
          context.commit('setPopups', response.data.data);
          context.commit('setLoadedAt', Date.now() / 1000);
          return true;
        })
        .catch(error => {
          return false;
        });
  },
};

// mutations
const mutations = {
  setPopups: (state, popups) => {
    state.popups = popups;
  },
  setLoadedAt: (state, time) => {
    state.loadedAt = time;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
